/* wl-mobile.js — Wuffy Lab mobile first (ajout 2026-09-06) : ancres fiables, ATC des cartes → cart drawer, swipe galerie PDP, Échap ferme le menu */
(function () {
  'use strict';
  if (window.__wlMobileInit) { return; }
  window.__wlMobileInit = true;
  function ready(fn) { if (document.readyState !== 'loading') { fn(); } else { document.addEventListener('DOMContentLoaded', fn); } }

  function closeNav() {
    var d = document.getElementById('wl-nav-drawer');
    if (d && !d.hidden) { var c = document.querySelector('[data-wl-nav-close]'); if (c) c.click(); }
  }
  function scrollToId(id, smooth) {
    var t = document.getElementById(id);
    if (!t) return false;
    t.style.scrollMarginTop = '80px';
    try { t.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' }); } catch (err) { t.scrollIntoView(); }
    return true;
  }

  /* 1. Liens d'ancre "/#diagnostic", "#faq"… : Horizon intercepte les clics de liens et n'ouvre pas l'ancre.
        Si la cible est sur la page → scroll (fonctionne aussi avec le scroll interne .page-wrapper de Horizon) ; sinon navigation normale. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    var m = /^(\/(?:\?[^#]*)?)?#([\w-]+)$/.exec(a.getAttribute('href') || '');
    if (!m) return;
    /* "/#faq" vise la home : depuis une autre page → navigation complète (les transitions de page Horizon perdent le #), scroll à l'arrivée */
    var quiz = document.querySelector('[data-wlq]');
    if (m[1] && location.pathname !== '/') {
      e.preventDefault(); e.stopPropagation();
      try { sessionStorage.setItem('wlAnchor', m[2]); } catch (err) {}
      /* #diagnostic : la home ouvre le quiz directement avec ?start=1 (wl-quiz-cta.liquid) */
      window.location.href = (m[2] === 'diagnostic' ? '/?start=1' : '/') + '#' + m[2];
      return;
    }
    /* #diagnostic sur la home : ouvrir le quiz (bouton [data-wlq-open] de wl-quiz-cta.liquid), pas seulement scroller */
    if (m[2] === 'diagnostic' && quiz) {
      var opener = document.querySelector('[data-wlq-open]');
      if (opener && !a.hasAttribute('data-wlq-open')) { e.preventDefault(); e.stopPropagation(); closeNav(); opener.click(); return; }
    }
    if (!document.getElementById(m[2])) return;
    e.preventDefault(); e.stopPropagation();
    closeNav();
    scrollToId(m[2], true);
    try { history.replaceState(null, '', '#' + m[2]); } catch (err) {}
  }, true);

  /* 2. Boutons "Ajouter au panier" des cartes (home Essentiels, [data-wl-atc]) : ajout AJAX puis ouverture du cart drawer
        (wl-app.js redirige vers /cart, la page Horizon par défaut). Si le drawer n'existe pas → comportement d'origine. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-wl-atc]') : null;
    if (!btn) return;
    var id = btn.getAttribute('data-variant-id');
    var drawer = document.getElementById('wl-cart');
    if (!id || !drawer) return;
    e.preventDefault(); e.stopPropagation();
    var label = btn.innerHTML; btn.disabled = true; btn.innerHTML = '…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        /* wl-cart.js ouvre le tiroir sur tout clic d'un lien vers /cart */
        var a = document.createElement('a'); a.href = '/cart'; a.setAttribute('href', '/cart'); a.style.display = 'none';
        document.body.appendChild(a); a.click(); a.parentNode.removeChild(a);
      })
      .catch(function () { window.location.href = '/cart'; })
      .then(function () { btn.innerHTML = label; btn.disabled = false; });
  }, true);

  ready(function () {
    /* Arrivée avec une ancre (#diagnostic depuis une PDP) */
    var stored = null;
    try { stored = sessionStorage.getItem('wlAnchor'); if (stored) sessionStorage.removeItem('wlAnchor'); } catch (err) {}
    var target = (location.hash && location.hash.length > 1) ? location.hash.slice(1) : stored;
    if (target) { setTimeout(function () { scrollToId(target, false); }, 350); setTimeout(function () { scrollToId(target, false); }, 1200); }

    /* Échap ferme le drawer de navigation (le clic sur l'overlay est déjà géré par wl-app.js) */
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeNav(); });

    /* Galerie PDP : swipe horizontal = image suivante / précédente, la miniature active reste visible */
    var g = document.querySelector('[data-wl-gallery]');
    if (!g) return;
    var first = g.querySelector('[data-wl-slide]');
    var stage = first ? first.parentElement : null;
    if (!stage) return;
    var syncThumb = function () {
      setTimeout(function () {
        var th = g.querySelector('[data-wl-thumb][aria-current="true"]');
        if (th && th.scrollIntoView) { try { th.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' }); } catch (err) { th.scrollIntoView(); } }
      }, 0);
    };
    g.querySelectorAll('[data-wl-media-prev],[data-wl-media-next]').forEach(function (b) { b.addEventListener('click', syncThumb); });
    var x0 = null, y0 = 0, t0 = 0;
    stage.addEventListener('touchstart', function (e) { var t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; t0 = Date.now(); }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0]; var dx = t.clientX - x0, dy = t.clientY - y0; x0 = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2 || Date.now() - t0 > 800) return;
      var btn = g.querySelector(dx < 0 ? '[data-wl-media-next]' : '[data-wl-media-prev]');
      if (btn) { btn.click(); }
    }, { passive: true });
  });
})();
